import { server } from '@/config/urls'
import { joinValues } from '@/utils/urls'

export const userSettingsUrls = {
  userInfo: joinValues(server, 'user'),
  getUserInfo: (userId: string) => joinValues(server, 'user', userId),
  preferencesUrl: joinValues(server, 'user/preferences'),
  mfa: {
    initiateMfa: joinValues(server, 'user/mfa/initiate'),
    enableMfa: joinValues(server, 'user/mfa/enable'),
    disableMfa: joinValues(server, 'user/mfa/disable'),
    verifyQrcode: joinValues(server, 'user/mfa/verify'),
    qrCodeMfa: joinValues(server, 'user/mfa/qr_code'),
    recoverycodesMfa: joinValues(server, 'user/mfa/recovery_codes'),
  },
  emails: {
    default: joinValues(server, 'user/emails'),
    email: (emailId: string): string =>
      joinValues(server, 'user/emails', emailId),
    primary: (emailId: string): string =>
      joinValues(server, 'user/emails', emailId, 'primary'),
    verify: (emailId: string): string =>
      joinValues(server, 'user/emails', emailId, 'verify'),
  },
  notificationChannels: joinValues(server, 'user/notification_channels'),
  notificationChannelTopics: ({ channel }: { channel: string }): string =>
    joinValues(server, 'user/notification_channels', channel, 'topics'),
}
